import { Link } from "react-router-dom";
import { Camera, Sparkles, ShoppingBasket, Heart, ArrowRight } from "lucide-react";

const HERO = "https://images.unsplash.com/photo-1767023027863-9e03d58a0d98?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const FEATURES = [
  { icon: Camera, title: "Scatta il frigo", text: "Una foto e l'AI riconosce verdure, latticini, avanzi e dispensa." },
  { icon: Sparkles, title: "Ricette su misura", text: "Sei idee con ciò che hai già, filtrate per la tua dieta." },
  { icon: ShoppingBasket, title: "Spesa intelligente", text: "Gli ingredienti mancanti finiscono in lista con un tocco." },
  { icon: Heart, title: "Preferiti e storico", text: "Salva le ricette migliori e ritrova ogni frigo analizzato." },
];

export default function Landing() {
  return (
    <div className="relative z-10 min-h-screen" data-testid="landing-page">
      <header className="flex items-center justify-between px-5 sm:px-10 py-5">
        <span data-testid="header-logo" className="font-display text-2xl font-extrabold text-[#2E6F40]">
          Svuota<span className="text-[#D95338]">Frigo</span>
        </span>
        <Link to="/sign-in" data-testid="auth-login-button"
          className="rounded-full border border-[#2E6F40]/30 px-5 py-2 text-sm font-semibold text-[#2E6F40] transition-colors hover:bg-[#E8F3EA]">
          Accedi
        </Link>
      </header>

      <section className="grid lg:grid-cols-[1.1fr_1fr] gap-10 lg:gap-16 px-5 sm:px-10 pt-6 pb-16 items-center max-w-7xl mx-auto">
        <div className="rise">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#D95338] mb-5">Anti-spreco · AI in cucina</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] text-[#1C241E]">
            Apri il frigo.<br />Scatta.<br /><span className="italic text-[#2E6F40]">Cucina.</span>
          </h1>
          <p className="mt-6 max-w-md text-base text-[#4F5D52] leading-relaxed">
            Fotografa quello che hai in frigo e scopri subito quali ricette puoi preparare, senza buttare nulla.
          </p>
          <div className="mt-9 flex flex-wrap gap-3">
            <Link to="/sign-up" data-testid="landing-cta-button"
              className="group inline-flex items-center gap-2 rounded-full bg-[#2E6F40] px-7 py-3.5 font-semibold text-white shadow-lg shadow-[#2E6F40]/20 transition-transform hover:-translate-y-0.5 hover:bg-[#235732]">
              Inizia gratis <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
            <Link to="/sign-in" data-testid="landing-signin-link"
              className="inline-flex items-center rounded-full px-6 py-3.5 font-semibold text-[#1C241E] hover:bg-black/5 transition-colors">
              Ho già un account
            </Link>
          </div>
        </div>
        <div className="relative rise" style={{ animationDelay: ".15s" }}>
          <div className="absolute -inset-4 rounded-[2.5rem] bg-[#D95338]/10 rotate-2" />
          <img src={HERO} alt="Frigo con verdure fresche" className="relative aspect-[4/5] w-full rounded-[2rem] object-cover shadow-2xl" />
          <div className="absolute bottom-5 left-5 right-5 rounded-2xl bg-white/85 backdrop-blur-xl p-4 shadow-lg">
            <p className="text-xs font-semibold uppercase tracking-wider text-[#2E6F40]">Trovati 9 ingredienti</p>
            <p className="font-display text-lg font-bold mt-1">Frittata di zucchine e menta</p>
            <p className="font-mono text-xs text-[#4F5D52] mt-1">15 min · Facile · 0 mancanti</p>
          </div>
        </div>
      </section>

      <section className="px-5 sm:px-10 pb-20 max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {FEATURES.map((f, i) => (
          <div key={f.title} className="rise rounded-3xl border border-[#1C241E]/10 bg-white p-6" style={{ animationDelay: `${0.2 + i * 0.08}s` }}>
            <f.icon className="h-6 w-6 text-[#D95338]" />
            <h3 className="mt-4 font-display text-lg font-bold">{f.title}</h3>
            <p className="mt-2 text-sm text-[#4F5D52]">{f.text}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
